import React from "react";
import { Redirect, Route } from "react-router-dom";
import { errorToast } from "utils/toast";
import noneAuthPages from "../../constants/noneAuthPages";
import Auth from "../../services/authentication/";

const AuthRoute = ({ render, ...props }) => {
  const auth = new Auth();
  return (
    <Route
      {...props}
      render={() => {
        if (auth.isAuthenticated()) {
          return render(props);
        } else if (!noneAuthPages.includes(window.location.pathname)) {
          return <Redirect to="/login" />;
        } else {
          // read querystring values to get "error"
          const urlParams = new URLSearchParams(window.location.search);
          const error = urlParams.get("error");

          if (error) {
            if (error === "app-denied") {
              errorToast(
                "You do not have permission to access this site.  Please contact IT Support.",
              );
            } else if (error === "account-inactive") {
              errorToast(
                "Your account has been disabled.  Please contact IT Support.",
              );
            }
          }
          return null;
        }
      }}
    />
  );
};

export default AuthRoute;
